import styled from 'styled-components';
import { Select as MuiSelect, TextField as MuiTextField } from '@material-ui/core';

export const HiddenElement = styled.span`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1;
  margin: -1;
  overflow: hidden;
  padding: 0;
  position: absolute;
  top: 20;
  width: 1;
`;

export const StyledTableHeadSelect = styled(MuiSelect)`
    .MuiSelect-select:focus {
        background-color: inherit;
    }
`;

export const TableHeadTextField = styled(MuiTextField)`
    width: 100%;
    .MuiInput-input::placeholder {
        text-transform: uppercase;
        opacity: 1;
        ${({ theme }) => `
            color: ${theme.palette.text.secondary};
            font-weight: ${theme.typography.fontWeightRegular};
            font-size: 0.75rem;
            line-height: 1.5;
            letter-spacing: 0.00375rem;
        `}
    }
`;